import React from 'react'
import Tag from '../../../../../widgets/Typography/Tag'
import Title from '../../../../../widgets/Typography/Title'
import RelativeTimeWithIcon from '../../../../../widgets/Temporal/RelativeTimeWithIcon'
import BookmarkButton from '../../../BookmarkButton'
import ShareButton from '../../../../Sharing/ShareButton'
import PropTypes from 'prop-types'
import { getLocales } from '../../../../../utilities/locales'
import Text from '../../../../../widgets/Typography/Text'
import { isDefined } from '../../../../../utilities/strings'
import styles from './Information.module.css'
import translate from '../../../../../utilities/translate'
import translations from './translations'

const trans = translate(translations)

const titleSizeMapping = {
  'large': 'extra-large',
}

const Information = ({
  article,
  locale,
  size = 'default',
  color = 'default',
  variant = 'default',
  sponsoredTitle = null,
}) =>
  <div className={ [
    styles.wrapper,
    styles[`size-${size}`] ?? '',
    styles[`variant-${variant}`] ?? '',
    styles[`color-${color}`] ?? '',
  ].join(' ') }>
    <div className={ styles['top-information'] }>
      { sponsoredTitle
        ? <Tag variant="sponsored">{ sponsoredTitle }</Tag>
        : <Tag color={ color }>{article.category.name}</Tag>
      }
      <Title size={ titleSizeMapping[size] } color={ color }>{ article.title }</Title>
      <div className={ styles.excerpt }>
        <Text>{ article.excerpt }</Text>
      </div>
    </div>
    <div className={ styles['bottom-information'] }>
      { ['author', 'author-full-date'].includes(variant)
        ? <span className={ styles.signature }>
          { article.signatures.map(signature => signature.authorName).join(', ') }
        </span>
        : null
      }
      <div className={ styles['date-wrapper'] }>
        <div className={ styles['sr-only'] }>
          <Text size="small">{trans(locale)('readingTime', { time: article.readingTime })}</Text>
        </div>
        <div className={ styles['date'] }>
          <RelativeTimeWithIcon
            date={ article.updatedAt }
            locale={ locale }
            variant={ variant === 'author-full-date' ? 'full' : 'default' }
            color={ color }
          />
        </div>
        { variant === 'author-full-date'
          ? <div className={ styles['mobile-date'] }>
            <RelativeTimeWithIcon date={ article.updatedAt } locale={ locale } color={ color } />
          </div>
          : null
        }
        <div className={ styles.actions }>
          <BookmarkButton articleId={ article.id } height={ 16 } width={ 16 } />
          <ShareButton
            url={ article.frontendUrl }
            title={ article.title.replace(/\s/g, ' ') }
            excerpt={ article.excerpt }
            height={ 16 }
            width={ 16 }
            color={ color }
          />
        </div>
      </div>
    </div>
  </div>

Information.propTypes = {
  article: PropTypes.object.isRequired,
  locale: PropTypes.oneOf(getLocales()).isRequired,
  size: PropTypes.oneOf(['large', 'default', 'small']),
  color: PropTypes.oneOf(['default', 'light-mobile']),
  variant: PropTypes.oneOf([
    'default',
    'author',
    'author-full-date',
  ]),
  sponsoredTitle: PropTypes.string,
}

const Placeholder = ({ size = 'default' }) =>
  <div className={ `${styles.wrapper} ${styles[`size-${size}`] ?? ''} ${styles.placeholder}` } />

Information.Placeholder = Placeholder

export default Information
